import { showError } from "actions/notification";
import { logoutUser } from "actions/user";
import { push } from "connected-react-router";

import Translate from "utils/translate";

const { t } = new Translate("notifications");

const defaultError =
  ({ message, title }) =>
  (dispatch) => {
    dispatch(showError(title, message));
  };

const forbidden =
  ({ message, title }) =>
  (dispatch) => {
    dispatch(showError(title, message));
    dispatch(push("/"));
  };

const notAuthenticated = () => (dispatch) => {
  dispatch(showError(t("notAuthenticated.title"), t("notAuthenticated.message")));
  dispatch(logoutUser());
};

const notFound =
  ({ message, title }) =>
  (dispatch) => {
    dispatch(showError(title, message));
    dispatch(push("/"));
  };

const errors = {
  401: notAuthenticated,
  403: forbidden,
  404: notFound,
  default: defaultError,
};

export default (error) => (dispatch) => {
  if (!error) return null;

  return (errors[error.status] || errors.default)(error)(dispatch);
};
